/**
 * ADP-271: the demo data generation this page was loaded against. Sent with
 * every write so a demo deployment can refuse writes from a page opened before
 * the workspace was restored (see the API's demo-generation plugin).
 */
let current: string | null = null;

export const DEMO_GENERATION_HEADER = "X-Demo-Generation";

export function setDemoGeneration(workspaceId: string, completedAt: string | null): void {
  // Only set once per page: a restore elsewhere must not silently re-arm an old page.
  if (current === null && completedAt) current = `${workspaceId}:${completedAt}`;
}

export function demoGeneration(): string | null {
  return current;
}

/** On sign-out: the next account in this tab arms its own generation. */
export function resetDemoGeneration(): void {
  current = null;
}
